export default __webpack_public_path__ + "static/media/illustration-work-3-w@3x.aa65e8f3.png";